import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 11.13H22V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V4C2 2.9 2.9 2 4 2H12.61V4H4V20H20V11.13ZM8.64 11.25V15.36H12.75L13.34 14.77L18.72 9.39L17.31 7.98L11.93 13.36H10.65V12.08L16.03 6.7L14.62 5.29L9.24 10.67L8.65 11.26L8.64 11.25ZM17.19 5.54L17.9 4.83L19.18 6.11L18.47 6.82L18.09 7.2L19.5 8.61L19.88 8.23L20.59 7.52L22 6.11L20.59 4.7L19.31 3.42L17.9 2.01L16.49 3.42L15.78 4.13L15.4 4.51L16.81 5.92L17.19 5.54Z" fill={ fill || 'currentColor' } />
    </svg>
);
